<div
  class="flex min-w-[462px] flex-col gap-5 bg-surface-0 p-12 shadow-xl shadow-surface-200
    rounded-border"
  [ngClass]="{ 'max-w-[462px]': errorStore.error().ok === undefined }">
  @if (invitationIssue()) {
    <div>
      @if (invitationIssue() === 'used') {
        <h3
          class="mb-2 inline-flex items-center gap-2 font-medium text-surface-900"
          i18n>
          <ng-icon
            name="phosphorWarningCircle"
            class="text-2xl text-primary"></ng-icon>
          This invitation has already been used
        </h3>
        <small class="font-medium text-surface-600" i18n>
          Your account is already set up. Sign in with your email and password.
        </small>
      } @else {
        <h3
          class="mb-2 inline-flex items-center gap-2 font-medium text-surface-900"
          i18n>
          <ng-icon
            name="phosphorWarningCircle"
            class="text-2xl text-primary"></ng-icon>
          This invitation link is no longer valid
        </h3>
        <small class="font-medium text-surface-600" i18n>
          A newer invitation may have been sent to you. Use the link in the most
          recent invitation email, or ask your administrator to resend it.
        </small>
      }
    </div>

    <button
      pButton
      pRipple
      [label]="goToLoginLabel"
      data-testid="invalid-invitation-login"
      class="w-full !text-sm"
      (click)="navigationService.forward('/login')"></button>
  } @else {
    <div>
      <h3
        class="mb-2 inline-flex items-center gap-2 font-medium text-surface-900"
        i18n>
        <ng-icon
          name="phosphorCheckCircle"
          class="cursor-pointer text-2xl text-primary"></ng-icon>
        Email address verified
      </h3>
      <small class="font-medium text-surface-600" i18n>
        Finish setting up your account
      </small>
    </div>

    <form
      class="flex flex-col gap-3"
      [formGroup]="signUpForm"
      appPreventAutoFill>
      <p-floatlabel variant="in">
        <p-iconfield>
          <p-inputicon>
            <ng-icon name="phosphorUser" class="text-xl text-primary"></ng-icon>
          </p-inputicon>
          <input
            pInputText
            name="name"
            type="text"
            fluid
            formControlName="name" />
        </p-iconfield>
        <label for="name" i18n>Name</label>
      </p-floatlabel>

      <p-floatlabel variant="in">
        <p-iconfield>
          <p-inputicon>
            <ng-icon name="phosphorUser" class="text-xl text-primary"></ng-icon>
          </p-inputicon>
          <input
            pInputText
            name="lastName"
            type="text"
            fluid
            formControlName="lastName" />
        </p-iconfield>
        <label for="lastName" i18n>Last name</label>
      </p-floatlabel>

      <p-floatlabel variant="in">
        <p-datepicker
          iconDisplay="input"
          [showIcon]="true"
          [minDate]="minBirthdate"
          [maxDate]="maxBirthdate"
          formControlName="birthdate"
          name="birthdate"
          fluid>
          <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
            <ng-icon
              name="phosphorCalendarBlank"
              class="cursor-pointer text-xl text-primary"
              (click)="clickCallBack($event)"></ng-icon>
          </ng-template>
        </p-datepicker>
        <label for="birthdate" i18n>Birthdate</label>
      </p-floatlabel>

      <div class="phone flex w-full">
        <p-select
          [options]="Countries"
          optionLabel="phoneCode"
          formControlName="phoneCountry">
          <ng-template #selectedItem let-selectedCountry>
            <div class="flex items-center gap-2" *ngIf="selectedCountry">
              <span emoji-flag>{{ selectedCountry.emoji }}</span>
              <span class="text-muted-color"
                >({{ selectedCountry.phoneCode }})</span
              >
            </div>
          </ng-template>
          <ng-template let-country #item>
            <div class="flex items-center gap-2">
              <span emoji-flag>{{ country.emoji }}</span>
              <span>{{ country.name }}</span>
              <span class="text-muted-color">({{ country.phoneCode }})</span>
            </div>
          </ng-template>
        </p-select>

        <p-floatlabel variant="in" class="grow">
          <p-inputnumber
            fluid
            mode="decimal"
            [useGrouping]="false"
            maxlength="15"
            formControlName="phone" />
          <label for="birthdate" i18n>Phone</label>
        </p-floatlabel>
      </div>

      <p-floatlabel variant="in">
        <p-iconfield>
          <p-inputicon class="z-10">
            <ng-icon
              name="phosphorLockSimple"
              class="text-xl text-primary"></ng-icon>
          </p-inputicon>

          <p-password
            class="w-full"
            name="password"
            formControlName="password"
            toggleMask="true"
            fluid>
            <ng-template pTemplate="header">
              <div class="text-xm mb-4 font-semibold" i18n>Pick a password</div>
            </ng-template>
            <ng-template pTemplate="content">
              <div class="flex h-10 w-full flex-col gap-2">
                <div class="h-4 w-full rounded-full bg-surface-200">
                  <div
                    class="h-4 rounded-full"
                    [ngStyle]="{
                      width: passwordStrengthPercentile() + '%',
                      backgroundColor: passwordTextAndColor().color,
                    }"></div>
                </div>
                <p>{{ passwordTextAndColor().text }}</p>
              </div>
            </ng-template>
            <ng-template pTemplate="footer">
              <p-divider />
              <ul class="my-0 ml-2 pl-2 leading-normal">
                <li i18n>At least one lowercase</li>
                <li i18n>At least one uppercase</li>
                <li i18n>At least one number</li>
                <li i18n>At least one symbol</li>
                <li i18n>Cant's start or end with a space</li>
                <li i18n>Minimum 8 characters</li>
              </ul>
            </ng-template>

            <ng-template pTemplate="hideicon">
              <ng-icon
                name="phosphorEye"
                class="toggle-mask-icon cursor-pointer text-xl text-primary"></ng-icon>
            </ng-template>
            <ng-template pTemplate="showicon">
              <ng-icon
                name="phosphorEyeClosed"
                class="toggle-mask-icon cursor-pointer text-xl text-primary"></ng-icon>
            </ng-template>
          </p-password>
        </p-iconfield>
        <label for="password" i18n>Create a password</label>
      </p-floatlabel>

      <p-floatlabel variant="in">
        <p-iconfield>
          <p-inputicon class="z-10">
            <ng-icon
              name="phosphorLockSimple"
              class="text-xl text-primary"></ng-icon>
          </p-inputicon>

          <p-password
            class="w-full"
            name="confirmPassword"
            formControlName="confirmPassword"
            toggleMask="true"
            feedback="false"
            fluid>
            <ng-template pTemplate="hideicon">
              <ng-icon
                name="phosphorEye"
                class="toggle-mask-icon cursor-pointer text-xl text-primary"></ng-icon>
            </ng-template>
            <ng-template pTemplate="showicon">
              <ng-icon
                name="phosphorEyeClosed"
                class="toggle-mask-icon cursor-pointer text-xl text-primary"></ng-icon>
            </ng-template>
          </p-password>
        </p-iconfield>
        <label for="confirmPassword" i18n>Confirm password</label>
      </p-floatlabel>

      <div class="flex items-center gap-2">
        <p-checkbox
          name="conditionsCheckbox"
          [binary]="true"
          class="h-7"
          formControlName="conditionsCheckbox"></p-checkbox>
        <label for="conditionsCheckbox" class="text-xs text-surface-900" i18n>
          I accept the CXC
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://cxc-assets-staging.s3.us-east-2.amazonaws.com/portal/docs/Terminos.pdf"
            class="text-primary-600 underline"
            >Terms and Conditions</a
          >
          and acknowledge the
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://cxc-assets-staging.s3.us-east-2.amazonaws.com/portal/docs/Privacidad.pdf"
            class="text-primary-600 underline"
            >Privacy Policy</a
          >
        </label>
      </div>
    </form>

    <div class="flex min-h-7 flex-col">
      <error-small-component></error-small-component>
      <caps-lock-component></caps-lock-component>
    </div>

    <button
      pButton
      pRipple
      label="Sign In"
      class="w-full !text-sm"
      (click)="signUp()"></button>
  }
</div>
